// client/src/pages/admin/project-steps/constants.ts

export const SUBCATEGORIES: Record<string, string[]> = {
    'Residential': ['Flat/Apartment', 'Bungalow/Villa', 'Penthouse', 'Studio Apartment', 'Duplex'],
    'Commercial': ['Office Space', 'Shop / Showroom', 'Warehouse', 'Co-working Space'],
    'PG/Co-living': ['PG for Boys', 'PG for Girls', 'Co-living Space'],
    'Plot': ['Residential Plot', 'Commercial Plot'],
    'Land': ['Agricultural Land', 'Industrial Land'],
    'Bank Auction Property': ['Residential', 'Commercial', 'Industrial']
}

export const STEPS = [
    "Basic Details",
    "Location Details",
    "Developer Info",
    "Project Overview",
    "SEO & Timeline",
    "Floor Variants",
    "Gallery & Documents",
    "Highlights & Details",
    "Developer Offers",
    "Contact Details",
    "Review & Publish"
];

export const NEARBY_CATEGORY_ICONS: Record<string, string> = {
    'Bank': 'fa-building-columns',
    'Business Hubs': 'fa-building',
    'Cinema Halls': 'fa-film',
    'Colleges | Universities': 'fa-graduation-cap',
    'Hospitals': 'fa-hospital',
    'Hotels': 'fa-hotel',
    'Major Road Connectivity': 'fa-road',
    'Parks & Lakes': 'fa-tree',
    'Religious Place': 'fa-place-of-worship',
    'School': 'fa-school',
    'Shopping': 'fa-bag-shopping',
    'Transportation': 'fa-train',
    'Bus Stops': 'fa-bus',
    'Banks': 'fa-building-columns',
    'Temples': 'fa-place-of-worship',
    'ATMs': 'fa-money-bill-transfer',
    'Shopping Malls': 'fa-cart-shopping',
    'Mosques': 'fa-mosque',
    'Parks': 'fa-tree',
    'Post Offices': 'fa-envelope'
};

export const DEFAULT_CONSTRUCTION_STATUS_OPTIONS = [
    { label: 'RERA Approved', meaning: 'Legal clear, not started', score: 4 },
    { label: 'Under Construction', meaning: 'Work started', score: 6 },
    { label: 'Near Possession', meaning: '80–95% complete', score: 8 },
    { label: 'Ready to Move', meaning: 'OC received', score: 10 }
];

export const BANK_OPTIONS = [
    'SBI', 'HDFC Bank', 'ICICI Bank', 'Axis Bank', 'LIC Housing Finance', 'IDFC First Bank', 'Kotak Mahindra', 'Punjab National Bank', 'Bank of Baroda', 'Bajaj Finserv'
];
